// src/domains/auth/utils/refreshAccessToken.ts

import { refreshToken } from '@/domains/auth/auth.api';
import { useAuthStore } from '@/domains/auth/auth.store';

export async function refreshAccessToken(): Promise<string> {
  const { refreshToken: currentRefreshToken, setTokens } =
    useAuthStore.getState();

  if (!currentRefreshToken) {
    throw new Error('Refresh token not found');
  }

  const response = await refreshToken(currentRefreshToken);
  const newAccessToken = response.access_token;

  // save new access token, keeping same refresh
  await setTokens(newAccessToken, currentRefreshToken);

  return newAccessToken;
}
